import { BADGE_PROPS } from './constants'
import type { GetBadgeProps } from './types'

export const getBadgeProps = ({ isOffice, badgeType }: GetBadgeProps) => {
  if (!badgeType) return undefined

  const badge = BADGE_PROPS[badgeType as keyof typeof BADGE_PROPS]

  if (!badge) return undefined

  return {
    ...badge,
    tooltipText: isOffice ? badge.managerTooltip : badge.frontlinerTooltip,
  }
}
